(function () {
  function initHero(section) {
    if (section.dataset.heroInitialized === 'true') return;
    section.dataset.heroInitialized = 'true';

    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var canvas = section.querySelector('[data-hero-canvas]');
    var gsap = window.gsap;

    if (prefersReducedMotion) {
      section.classList.add('premium-hero--static');
    }

    if (gsap) {
      runEntrance(section, gsap, prefersReducedMotion);
    }

    var compactHero = window.matchMedia('(max-width: 989px)').matches;
    if (compactHero || !canvas || !window.WebGLRenderingContext) {
      return;
    }

    loadHeroScene(section.dataset.heroSceneSrc, function (error) {
      if (error || !window.PremiumHero) return;

      var heroInstance = window.PremiumHero.createHero(canvas, {
        reducedMotion: prefersReducedMotion,
        sculptureSrc: section.dataset.heroSculptureSrc,
        onReady: function () {
          section.classList.add('premium-hero--webgl');
          heroInstance.renderOnce();
        },
      });

      if (!heroInstance) return;
    });
  }

  function loadHeroScene(src, callback) {
    if (!src) {
      callback(new Error('missing hero scene source'));
      return;
    }

    if (window.PremiumHero) {
      callback();
      return;
    }

    var script = document.createElement('script');
    script.src = src;
    script.defer = true;
    script.onload = function () {
      callback();
    };
    script.onerror = function () {
      callback(new Error('failed to load hero scene'));
    };
    document.head.appendChild(script);
  }

  function observeVisibility(section, heroInstance) {
    if (!('IntersectionObserver' in window)) {
      heroInstance.start();
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        var isIntersecting = entries[0].isIntersecting;
        if (isIntersecting && !document.hidden) {
          heroInstance.start();
        } else {
          heroInstance.stop();
        }
      },
      { threshold: 0 }
    );

    observer.observe(section);

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        heroInstance.stop();
      } else {
        var rect = section.getBoundingClientRect();
        var inView = rect.bottom > 0 && rect.top < window.innerHeight;
        if (inView) heroInstance.start();
      }
    });
  }

  function runEntrance(section, gsap, prefersReducedMotion) {
    var sceneWrap = section.querySelector('[data-hero-scene]');
    var orbit = section.querySelector('.premium-hero__orbit');
    var eyebrow = section.querySelector('[data-hero-eyebrow]');
    var words = section.querySelectorAll('.premium-hero__word-inner');
    var subtext = section.querySelector('[data-hero-subtext]');
    var ctas = section.querySelector('[data-hero-ctas]');
    var trust = section.querySelector('[data-hero-trust]');
    var scrollCue = section.querySelector('[data-hero-scroll-cue]');

    if (prefersReducedMotion) return;

    var tl = gsap.timeline({ defaults: { ease: 'power3.out' } });

    if (orbit) {
      tl.fromTo(orbit, { opacity: 0 }, { opacity: 1, duration: 1.1 }, 0);
    }
    if (sceneWrap) {
      tl.fromTo(sceneWrap, { opacity: 0 }, { opacity: 1, duration: 1.4 }, 0.05);
    }
    if (eyebrow) {
      tl.fromTo(eyebrow, { opacity: 0, y: 10 }, { opacity: 1, y: 0, duration: 0.7 }, 0.3);
    }
    tl.fromTo(words, { yPercent: 120 }, { yPercent: 0, duration: 1, stagger: 0.08 }, 0.45);

    if (subtext) {
      tl.fromTo(subtext, { opacity: 0, y: 16 }, { opacity: 1, y: 0, duration: 0.8 }, 0.9);
    }
    if (ctas) {
      tl.fromTo(ctas, { opacity: 0, y: 16 }, { opacity: 1, y: 0, duration: 0.8 }, 1.05);
    }
    if (trust) {
      tl.fromTo(trust, { opacity: 0, y: 12 }, { opacity: 1, y: 0, duration: 0.7 }, 1.2);
    }
    if (scrollCue) {
      tl.fromTo(scrollCue, { opacity: 0 }, { opacity: 1, duration: 0.6 }, 1.35);
    }
  }

  function setupScrollExit(section, gsap, heroInstance, content, sceneWrap, scrollCue) {
    window.ScrollTrigger.create({
      trigger: section,
      start: 'top top',
      end: 'bottom top',
      scrub: true,
      onUpdate: function (self) {
        var progress = self.progress;

        if (heroInstance) {
          heroInstance.setScrollProgress(progress);
        }
        if (content) {
          gsap.set(content, { opacity: 1 - progress * 1.1, y: progress * -60 });
        }
        if (scrollCue) {
          gsap.set(scrollCue, { opacity: 1 - progress * 3 });
        }
      },
    });
  }

  function init() {
    var sections = document.querySelectorAll('[data-premium-hero]');
    sections.forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-premium-hero]');
    if (section) initHero(section);
  });
})();
